import { ShieldCheck } from "lucide-react";

const ITEMS = ["Gas Safety (CP12)", "EICR every 5 years", "EPC rating E+", "Smoke & CO alarms", "Deposit protected in 30 days", "Right to Rent checks", "Rent Smart Wales licence", "Scottish landlord registration", "Legionella risk assessment", "HMO licensing", "Law Change Radar", "Court-ready Evidence Pack", "Sell with tenant in place", "Contractor before/after photos"];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="marquee-banner" className="bg-emerald-brand text-white overflow-hidden border-y border-emerald-deep/40 select-none">
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        {row.map((t, i) => (
          <span key={i} className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold whitespace-nowrap">
            <ShieldCheck size={14} className="opacity-80" /> {t}
          </span>
        ))}
      </div>
    </div>
  );
}
